import React, { useEffect, useState, Suspense } from "react";
import { useParams } from "react-router-dom";
import {
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Area,
  AreaChart,
  ResponsiveContainer,
} from "recharts";
import {
  ChartContainer,
  DatePicker,
  MarketPriceTable,
  MoreButton,
} from "./DashboardMarketPriceStyle";
import ArrowDownSvg from "assets/images/icons/arrow_down.svg";
import { DashBoardCreators, moreLoadChartData } from "redux/modules/dashboard";
import { useDispatch, useSelector } from "react-redux";
import DashboardCustomTooltip from "./DashboardCustomTooltip";
import Spinner from "components/common/Spinner";

const DashboardMarketPrice = (props) => {
  const dispatch = useDispatch();
  const [dayActive, setDayActive] = useState(0);
  const [day, setDay] = useState(7);
  const dashBoardState = useSelector((state) => state.dashboard);
  const chartList = dashBoardState.chartList
    ? [...dashBoardState?.chartList].reverse()
    : undefined;
  const { f_id } = useParams();
  const useDashboard = useSelector((state) => state.dashboard);
  const isChartListLoading = useSelector(
    (state) => state.dashboard.isChartListLoading
  );

  function activeDayClass(dayPick) {
    return dayActive === dayPick ? "active" : "";
  }

  function changeDays(index, changeDay) {
    setDayActive(index);
    setDay(changeDay);
    dispatch(
      DashBoardCreators.fetchChartData({
        f_id,
        day: changeDay,
      })
    );
  }

  function priceCheck(price) {
    return price ? Number(price).toLocaleString() : "- ";
  }

  useEffect(() => {
    if (props.nameSearch === true) {
      const defaultChartSet = {
        f_id: useDashboard.searchList.data[0].f_id,
        day,
      };
      dispatch(DashBoardCreators.fetchChartData(defaultChartSet));
    } else {
      const defaultChartSet = {
        f_id,
        day,
      };
      dispatch(DashBoardCreators.fetchChartData(defaultChartSet));
    }
  }, []);

  return (
    <>
      <ChartContainer>
        <h2>시세</h2>
        <DatePicker>
          <li className={activeDayClass(0)} onClick={() => changeDays(0, 7)}>
            1주일
          </li>
          <li className={activeDayClass(1)} onClick={() => changeDays(1, 30)}>
            1개월
          </li>
          <li className={activeDayClass(2)} onClick={() => changeDays(2, 90)}>
            3개월
          </li>
          <li className={activeDayClass(3)} onClick={() => changeDays(3, 365)}>
            1년
          </li>
        </DatePicker>
        {chartList?.length > 0 && isChartListLoading ? (
          <ResponsiveContainer width="100%" height={230}>
            <AreaChart
              data={chartList}
              margin={{ top: 16, right: 16, left: 0, bottom: 0 }}
            >
              <defs>
                <linearGradient id="coloravg_p" x1="0" y1="0" x2="0" y2="1">
                  <stop offset="0%" stopColor="#FF7A00" stopOpacity={0.2} />
                  <stop offset="100%" stopColor="#FF7A00" stopOpacity={0} />
                </linearGradient>
              </defs>
              <XAxis dataKey="f_date" />
              <YAxis />
              <CartesianGrid
                strokeDasharray="0"
                stroke="#EAECEF"
                vertical={false}
              />
              <Tooltip content={<DashboardCustomTooltip />} />
              <Area
                type="monotone"
                dataKey="avgPrice"
                stroke="#FF7A00"
                fillOpacity={1}
                fill="url(#coloravg_p)"
              />
            </AreaChart>
          </ResponsiveContainer>
        ) : isChartListLoading ? (
          <div>
            최근 거래 내역이 없어요. <br />
            다른 기간 필터를 선택하면, 과거 데이터를 볼 수 있어요.
          </div>
        ) : (
          <Spinner width={200} height={200} />
        )}
        <MarketPriceTable>
          <tbody>
            <tr>
              <th>거래일</th>
              <th>최저가</th>
              <th>최고가</th>
              <th>평균가</th>
            </tr>
            {dashBoardState.showChartList?.map((item, index) => (
              <tr key={index}>
                <td>{item?.f_date}</td>
                <td>{priceCheck(item?.minPrice)}원</td>
                <td>{priceCheck(item?.maxPrice)}원</td>
                <td>{priceCheck(item?.avgPrice)}원</td>
              </tr>
            ))}
          </tbody>
        </MarketPriceTable>
        {dashBoardState.isMore ? (
          <MoreButton onClick={() => dispatch(moreLoadChartData())}>
            거래 내역 더보기
            <img src={ArrowDownSvg} alt="More button" />
          </MoreButton>
        ) : (
          ""
        )}
      </ChartContainer>
    </>
  );
};

export default DashboardMarketPrice;
